import { jsx as _jsx } from "react/jsx-runtime";
const ArrowDown = props => /*#__PURE__*/_jsx("svg", Object.assign({
  width: "8",
  height: "8",
  viewBox: "0 0 8 8"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M0.667621 1.74999H0.6655C0.481236 1.74999 0.314854 1.82546 0.19484 1.94698C0.0742204 2.06973 -3.05176e-05 2.23853 -3.05176e-05 2.42431C-3.05176e-05 2.61009 0.0742204 2.77859 0.195143 2.90164L3.52886 6.28081C3.64887 6.40295 3.81555 6.47841 4.00012 6.47841C4.18469 6.47841 4.35137 6.40264 4.47139 6.28081L7.8051 2.90164C7.92572 2.7789 7.99997 2.61009 7.99997 2.42431C7.99997 2.23853 7.92572 2.06973 7.8048 1.94698C7.68509 1.82546 7.51901 1.7503 7.33505 1.74999H0.667621Z"
  })
}));
export default ArrowDown;